// Evaluation criteria are the trainer's own checklist that the AI applies
// while judging each question (specs/2026-10-16-ai-eval-question-focus.md).
// New assignments start with this standard checklist so trainers don't have
// to retype it every time - it stays fully editable per assignment.
export const DEFAULT_EVAL_CRITERIA: ReadonlyArray<{ readonly name: string }> = [
    'Check whether the assignments are AI generated.',
    'Are all questions answered?',
    'Any questions where the quality of response is not adequate?',
    'Is any concept not clear to them basis their response?',
    'Do they disagree with any concept?',
    'Do they have any questions which need an answer?',
    'Does their thinking need to be challenged for any of the responses?',
    'Any other action needed by the facilitator on their response?',
].map(name => ({ name }));

// A fresh, mutable copy for a new assignment.
export const defaultEvalCriteria = (): { name: string }[] => DEFAULT_EVAL_CRITERIA.map(c => ({ name: c.name }));

// The `evalcriteria` value stored on an assignment: trimmed, blanks dropped,
// '' when there's nothing to store.
export const serializeEvalCriteria = (criteria?: { name: string }[]): string => {
    const filled = (criteria || [])
        .map(c => ({ name: (c.name || '').trim() }))
        .filter(c => c.name);
    return filled.length > 0 ? JSON.stringify(filled) : '';
};
